import {
  LOGOUT,
  REQUEST_USER,
  RECEIVE_USER,
  NOT_RECEIVE_USER,
  USER_ADD_ERROR,
  USER_REMOVE_ERRORS,
  USER_UPDATE,
  USER_UPDATE_FAILURE,
  USER_UPDATE_SUCCESS,
  CHANGE_LANGUAGE,
  CHANGE_LANGUAGE_SUCCESS,
  CHANGE_LANGUAGE_FAILURE,
  UPLOAD_AVATAR,
  UPLOAD_AVATAR_SUCCESS,
  UPLOAD_AVATAR_FAILURE,
  USER_RESET_ERRORS,
  FETCH_DEFAULT_COUNTRY_SUCCESS,
} from '../../constants/ActionTypes';

export default function userAuthReducer(state, action) {
  switch (action.type) {
    case LOGOUT:
      return {
        ...state,
        isFetching: false,
        isLogged: false,
        isLogOuting: true,
      };

    case CHANGE_LANGUAGE:
      return {
        ...state,
        isSaved: false,
        isNotSaved: false,
        isSending: true,
      };

    case CHANGE_LANGUAGE_SUCCESS:
      return {
        ...state,
        isSaved: true,
        isNotSaved: false,
        isSending: false,
        locale: action.locale,
      };

    case CHANGE_LANGUAGE_FAILURE:
      return {
        ...state,
        isSaved: false,
        isNotSaved: true,
        isSending: false,
      };

    case REQUEST_USER:
      return {
        ...state,
        isFetching: true,
        isInitial: false,
      };

    case USER_UPDATE:
      return {
        ...state,
        isSending: true,
        isNotSaved: false,
        isSaved: false,
      };

    case RECEIVE_USER: {
      let newUserData;
      if (action.payload.requisites === null) {
        newUserData = { ...action.payload, requisites: state.requisites };
      } else {
        newUserData = action.payload;
      }

      return {
        ...state,
        isFetching: false,
        isLogged: true,
        errors: [],
        ...newUserData,
      };
    }

    case USER_UPDATE_SUCCESS:
      return {
        ...state,
        isNotSaved: false,
        isSending: false,
        isSaved: true,
        isLogged: true,
        errors: [],
        ...action.payload,
      };

    case FETCH_DEFAULT_COUNTRY_SUCCESS:
      return {
        ...state,
        defaultCountry: action.payload,
      };

    case USER_UPDATE_FAILURE:
      return {
        ...state,
        isSending: false,
        isNotSaved: true,
        isSaved: false,
        errors: [...state.errors, action.error],
      };

    case USER_RESET_ERRORS:
      return {
        ...state,
        errors: [],
      };

    case NOT_RECEIVE_USER:
      return {
        ...state,
        isFetching: false,
      };

    case USER_ADD_ERROR:
      return {
        ...state,
        errors: [...state.errors, action.error],
      };

    case USER_REMOVE_ERRORS:
      return {
        ...state,
        errors: state.errors.filter((e) => e.section !== action.section),
      };

    case UPLOAD_AVATAR:
      return {
        ...state,
        isFetching: true,
      };

    case UPLOAD_AVATAR_SUCCESS:
      return {
        ...state,
        avatar: action.avatar,
        isFetching: false,
      };

    case UPLOAD_AVATAR_FAILURE:
      return {
        ...state,
        isFetching: false,
      };

    default:
      return state;
  }
}
